import React, { FC } from 'react'
import { useMediaAssetSettingsForm } from 'hooks/media/settings/useMediaAssetSettingsForm'
import { MovableModalContainer } from 'components/MovableModal'
import { isTransition } from 'Util/assets'
import MediaAssetSettingsForm from './Form'

const SettingsContainer: FC = () => {
  const { showSettings, onUpdateAsset, asset, type } = useMediaAssetSettingsForm()
  return (
    <MovableModalContainer
      height={isTransition(asset?.type) ? 350 : 520}
      visible={showSettings}
      windowId="SettingsContainer"
    >
      <MediaAssetSettingsForm
        type={type}
        asset={asset}
        onChange={onUpdateAsset}
        hideScrollBar={isTransition(asset?.type)}
        // ensure form is re-created and it's internal state, if any, is resetted
        key={asset?.id}
      />
    </MovableModalContainer>
  )
}
export default SettingsContainer
